module.exports = __webpack_public_path__ + "static/media/concha-shell.622d5e9d.svg";